module.exports = "/assets/js/5609bc01381f63765a030a0f2e8581ee.svg";